export const REGEX_EMAIL = /^\S+@\S+\.\S+$/;
export const REGEX_REMOVE_PARENTHESIS_AND_INNER_CONTENT = /\([^()]*\)/g;
